<template>
    <div>
        <b-modal v-model="showReleaseFormManager" size="lg" @ok="handleReleaseFormDidSelectItems" :ok-disabled="!releaseFormModalOk">
            <release-form-manager
                    ref="releaseFormManager"
                    @releaseFormSelected="releaseFormModalOk = true"
                    @releaseFormCleared="releaseFormModalOk = false"
                    @releaseFormsChanged="$emit('releaseFormsChanged', arguments[0])"
                    :accepted-files="releaseFormAcceptedFiles"
                    :initial-release-forms="initialReleaseForms"
                    :release-form-url="releaseFormUrl"/>
        </b-modal>

        <b-row>
            <b-col>
                <release-form-list ref="releaseFormList"
                                   :asset="asset"
                                   :readonly="disabled"
                                   :initial-release-forms="releaseForms"
                                   :only-trigger-changes="true"
                                   @removedReleaseForm="handleRemoveReleaseForm"
                                   @releaseRequiredEditableChanged="releaseRequiredEditable = arguments[0]"/>
            </b-col>
            <b-col cols="auto">
                <b-button variant="primary"
                          size="sm"
                          v-if="!disabled"
                          @click="handleAddRelease">Add Release Form
                </b-button>
                <b-button variant="secondary"
                          size="sm"
                          @click="changeReleaseRequired"
                          v-if="releaseRequiredEditable && !disabled">
                    No Release Needed
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import ReleaseFormManager from '../../ReleaseForms/ReleaseFormManager'
  import ReleaseFormList from '../../ReleaseForms/ReleaseFormList'
  import generalMixins from "../../../mixins/GeneralMixins";

  export default {
    props: ['releaseFormUrl', 'asset', 'releaseFormAcceptedFiles', 'releaseForms', 'initialReleaseForms', 'disabled'],

    model: {
      prop: 'releaseForms',
      event: 'change'
    },

    data: function () {
      return {
        releaseRequiredEditable: false,
        showReleaseFormManager: false,
        selectedReleaseForm: null,
        releaseFormModalOk: false
      }
    },

    methods: {
      handleRemoveReleaseForm(form) {
        if (form) {
          let existingForm = this.releaseForms.find(el => el.id === form.id)
          if (existingForm) {
            this.releaseForms.splice(this.releaseForms.indexOf(existingForm), 1);
          }
        }
      },

      handleReleaseFormDidSelectItems: function () {
        this.selectedReleaseForm = this.$refs.releaseFormManager.selectedReleaseForm;
        if (this.selectedReleaseForm) {
          const existing = this.releaseForms.find(el => el.id === this.selectedReleaseForm.id)

          if (!existing) {
            this.releaseForms.push(this.selectedReleaseForm)
            this.selectedReleaseForm = null
          }
        }
      },

      handleAddRelease: function () {
        this.showReleaseFormManager = true;
      },

      changeReleaseRequired: function () {
        this.$refs.releaseFormList.handleReleaseRequiredToggle();
        this.$emit('releaseRequiredChanged', this.$refs.releaseFormList.releaseRequired)
      }
    },

    mixins: [generalMixins],

    components: {ReleaseFormList, ReleaseFormManager}
  }
</script>